import React, { useEffect, useState } from "react";
import { Row, Col, Avatar, Menu, Dropdown } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import Logo from "../../Assets/login/Logo.svg";
import Cookies from "js-cookie";

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState("dashboard");
  useEffect(() => {
    let currentPath =
      location.pathname.split("/")[1] !== ""
        ? location.pathname.split("/")[1]
        : "dashboard";
    setCurrent(currentPath);
  }, [location]);

  const handleLogout = () => {
    const Email = localStorage.getItem("email");
    const Password = localStorage.getItem("password");
    localStorage.clear();
    Cookies.remove("access_token");
    if (Email && Password) {
      localStorage.setItem("email", Email);
      localStorage.setItem("password", Password);
    }
    navigate("/login");
  };
  // const handleClick = (e) => {
  //   console.log("eeeeeeeee", e);
  // };
  function getItem(label, link, key, children) {
    return {
      key,
      children,
      label: (
        <p
          className="menu_link"
          onClick={() => {
            if (link) {
              navigate(`/${link}`);
            }
          }}
        >
          {label}
        </p>
      ),
    };
  }
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const userId = localStorage.getItem("userId");
  const items = [
    getItem("Dashboard", "dashboard", "dashboard"),
    getItem("User Management", "user-management", "user-management"),
    getItem("Candidate  Management", "candidate-list", "candidate-list"),
    getItem("Client Management", "client-list", "client-list"),
    getItem("Campaign Management", "campaign-list", "campaign-list"),
    getItem("3rd Party Platforms", "externalclient", "externalclient"),
    getItem("Feed Management", "feed-management", "feed-management"),
    getItem("Subscription Management", "subscription", "subscription"),
    getItem("Support", "support", "support"),
    getItem("About Us", "about", "about"),
    getItem("Privacy Policy", "privacy-policy", "privacy-policy"),
    getItem("Terms & Conditions", "terms-conditions", "terms-conditions"),
    getItem("Settings", "", "", [
      getItem("Picklist", "picklist", "picklist"),
      getItem("Change Password", "change-password", "change-password"),
      getItem(
        "Manual Notification",
        "manual-notification",
        "manual-notification"
      ),
    ]),
  ];
  const userType = localStorage.getItem("userType");
  const dropdowndata = [
    {
      key: 1,
      label: (
        <div className="actionDropdown">
          <Row className="listItem">
            <Col
              span={24}
              className="item"
              onClick={() =>
                navigate(`/user-management/user-detail/view/${userId}`)
              }
            >
              My Profile
            </Col>
            <Col className="item" span={24} onClick={() => handleLogout()}>
              Log Out
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  return (
    <div className="layout_main_component">
      <div className="header">
        <Row
          justify={"space-between"}
          align={"middle"}
          style={{ height: "100px", padding: "0px 20px 0px 20px" }}
        >
          <Col>
            <img
              className="cursor-pointer"
              src={Logo}
              alt="menu"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </Col>
          <Col>
            <Row className="user-decs" align={"middle"}>
              <Col className="avatar-container">
                <Dropdown
                  placement="bottom"
                  menu={{
                    items: dropdowndata,
                  }}
                  overlayClassName="profileDropdown"
                >
                  <Avatar
                    size={45}
                    className="cursor-pointer"
                    icon=<span className="profileAvatarName">
                      {firstName ? firstName[0] : "A"}
                    </span>
                  />
                </Dropdown>
              </Col>
              <Col
              // style={{ cursor: "pointer" }}
              // onClick={() => navigate(`/user-detail/view/${userId}`)}
              >
                <p className="profileName">
                  {firstName?.charAt(0)?.toUpperCase() +
                    firstName?.substring(1, firstName?.length) +
                    " " +
                    (lastName?.charAt(0)?.toUpperCase() +
                      lastName?.substring(1, lastName?.length))}
                </p>
                <p className="designation">
                  {userType === "admin" ? "Admin" : "Standard Admin"}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div>
        <Row gutter={4}>
          <Col style={{ maxWidth: "270px", minWidth: "270px" }}>
            <div className="mainSidebar">
              <div>
                <Menu
                  mode="inline"
                  defaultSelectedKeys={[current]}
                  selectedKeys={[current]}
                  style={{
                    height: "100%",
                    borderRight: 0,
                  }}
                  items={items}
                />
              </div>
            </div>
          </Col>
          <Col className="contentMainContainer">
            <div className="mainContainer"> {children}</div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Layout;
